<template>
	<div class="loader">
		<span class="loader__spinner" :class="[`loader__spinner--${size}`, `loader__spinner--${theme}`]"></span>
	</div>
</template>
<script>
	export default {
		name: 'loader',
		props: {
			size: {
				type: String,
				default: null
			},
			theme: {
				type: String,
				default: null
			}
		},
	}
</script>
<style lang="scss">
.loader {
	position: absolute;
	width: 100%;
	height: 100%;
	top: 0;
	left: 0;
	display: flex;
	justify-content: center;
	align-items: center;
	color: white;
}
.loader__spinner {
	pointer-events: none;
	width: 1em;
	height: 1em;
	border: 0.05em solid transparent;
	border-color: transparent;
	border-top-color: #000000;
	border-radius: 50%;
	animation: spin 1s linear infinite;

	&--large {
		width: 5em;
		height: 5em;
		border: 0.35em solid transparent;
	}

	&--light {
		border-top-color: #ffffff;
	}
}
@keyframes spin {
	100% {
		transform: rotate(360deg)
	}
}
</style>
